import { useEffect, useState } from 'react'
import { hasSeenReferralBanner, markReferralBannerSeen } from '../utils/referralBannerBadge'

export default function ReferralBanner() {
  // The NEW badge shows on the banner's first appearance per browser. The initial
  // read runs before the effect's write, so StrictMode's repeated effect is a no-op.
  const [showNew] = useState(() => !hasSeenReferralBanner())

  useEffect(() => {
    if (showNew) markReferralBannerSeen()
  }, [showNew])

  return (
    <div className="referral-required-banner" role="note">
      <svg
        className="referral-required-banner__icon"
        width="18" height="18" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      >
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div className="referral-required-banner__body">
        <div className="referral-required-banner__title">
          <span>REFERRAL REQUIRED</span>
          {showNew && <span className="referral-required-banner__new-badge">NEW</span>}
        </div>
        <p className="referral-required-banner__text">
          PCP referral must be on file before patient is seen. Confirm referral is on file.
        </p>
      </div>
    </div>
  )
}
